module.exports = __webpack_public_path__ + "img/epoca-logo.207e9435.png";